/**
 * AlertPanel Component
 */

import React from 'react';
import { AlertTriangle, Info, AlertCircle, XCircle } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';

export default function AlertPanel({ alerts }) {
  if (!alerts || alerts.length === 0) {
    return (
      <div className="text-center text-slate-400 py-8">
        No alerts at this time
      </div>
    );
  }

  const getAlertIcon = (type) => {
    switch (type) {
      case 'critical': return XCircle;
      case 'warning': return AlertTriangle;
      case 'crisis_warning': return AlertTriangle;
      case 'info': return Info;
      default: return AlertCircle;
    }
  };

  const getAlertColor = (type) => {
    switch (type) {
      case 'critical': return 'text-red-500 bg-red-500/20 border-red-500';
      case 'warning': return 'text-yellow-500 bg-yellow-500/20 border-yellow-500';
      case 'crisis_warning': return 'text-orange-500 bg-orange-500/20 border-orange-500';
      case 'info': return 'text-blue-500 bg-blue-500/20 border-blue-500';
      default: return 'text-slate-400 bg-slate-500/20 border-slate-500';
    }
  };

  return (
    <div className="space-y-3">
      {alerts.map((alert, i) => {
        const Icon = getAlertIcon(alert.type);
        const colorClass = getAlertColor(alert.type);
        
        return (
          <div 
            key={alert.id || i} 
            className={`p-4 rounded-lg border-l-4 ${colorClass}`}
          >
            <div className="flex items-start">
              <Icon className="w-5 h-5 mr-3 mt-0.5 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="font-medium">
                  {alert.target || alert.title || 'Alert'}
                </div>
                {alert.probability && (
                  <div className="text-sm opacity-75">
                    Probability: {(alert.probability * 100).toFixed(1)}%
                  </div>
                )}
                {alert.timestamp && (
                  <div className="text-xs opacity-50 mt-1">
                    {formatDistanceToNow(new Date(alert.timestamp), { addSuffix: true })}
                  </div>
                )}
              </div>
              {!alert.acknowledged && (
                <div className="w-2 h-2 bg-current rounded-full flex-shrink-0" />
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
